import * as mainApi from 'util/server/mainApi'

export function fetchDrivingSummary(range) {
  return (dispatch) => {
    return mainApi.getDrivingSummary(range?.start, range?.end).then((resp) => {
      if (resp.data?.summary) {
        return dispatch({ type: 'SET_DRIVING_SUMMARY', summary: resp.data.summary })
      } else {
        return dispatch({ type: 'SET_DRIVING_SUMMARY', summary: null })
      }
    })
  }
}
